import { useEffect, useMemo, useState } from 'react';
import { useSiteContext, useTranslation } from '@eti/providers';
// eslint-disable-next-line import/no-unresolved
import unavailableIcon from '@eti/assets/icons/seating-buttons/default/seatButton-unavailable.svg?url';
import { getSeatIconUrl } from '../../../utils/getSeatIconUrl';
import { getSeatCharacteristicLabels } from '../utils/seatCharacteristicText';
export const useSeatCharacteristicMeta = (characteristic, isUnavailable) => {
  const {
    brand
  } = useSiteContext();
  const {
    t
  } = useTranslation();
  const priceFromLabel = t('Product.SeatMap.Characteristic.PriceFrom.Text');
  const [iconUrl, setIconUrl] = useState();
  useEffect(() => {
    const loadIcon = async () => {
      try {
        if (isUnavailable) {
          setIconUrl(unavailableIcon);
        } else if (characteristic) {
          const url = await getSeatIconUrl(brand.code, characteristic);
          setIconUrl(url);
        }
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }
    };
    loadIcon();
  }, [brand, characteristic, isUnavailable]);
  const [label, description] = useMemo(() => getSeatCharacteristicLabels(characteristic, isUnavailable, t), [characteristic, isUnavailable, t]);
  return {
    iconUrl,
    label,
    description,
    priceFromLabel
  };
};
//# sourceMappingURL=useSeatCharacteristicMeta.js.map